import React, { useEffect, useState } from 'react';
import Dropdown from "shared/components/Dropdown";
import SaveAsTemplate from "shared/components/SaveAsTemplate";

const TemplatesButton = ({ templates_url, save_as_template_url, template_id }) => {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const dropDownContent = <><i className="fi fi-template-2"/>{i18n.t('templates_ctrl.title')}</>;
  return (
    <>
      <Dropdown name={dropDownContent}
                klass="btn btn-success-inverse btn-with-icon"
                icon="caret"
                withFinish={false}
      >
        <a className="shared-dropdown__item" href={templates_url}>
          {i18n.t('templates_ctrl.change')}
        </a>
        {save_as_template_url && 
          <a className="shared-dropdown__item" onClick={() => setOpen(true)}>
            {i18n.t('templates_ctrl.save_as')}
          </a>
        }
      </Dropdown>
      {(open && save_as_template_url) &&
        <SaveAsTemplate
          onClose={onClose}
          save_as_template_url={save_as_template_url}
          template_id={template_id}
        />
      }
    </>
  );
};

export default TemplatesButton;
